<template>
	<div :class="{'has-danger': !isValid && required}">
		<div class="multiselect" v-click-outside="handleOutsideClick" @keyup.escape="handleEscape">
			<button class="multiselect-btn" data-testid="multiSelectFilterBtn" :class="{'is-active':selectVisible}" :aria-expanded="selectVisible ? 'true' : 'false'" :disabled="isDisabled()" @click="toggle" :ref="toggleButtonRef">{{ placeholder }}</button>
			<div class="multiselect-wrap" :aria-hidden="!selectVisible">
				<fieldset class="multiselect-group">
					<legend class="sr-only">{{ placeholder }}</legend>
					<div v-for="(group, groupIdx) in items" :key="groupIdx">
						<div v-if="group.name" class="multiselect-subheading">{{ group.name }}</div>
						<label v-for="(item, idx) in filteredGroupChoices(group)" class="c-input c-checkbox-sm" data-testid="multiselectFilterOption" :key="idx" :class="{disabled: !item.enabled}">
							<input
								type="checkbox"
								:id="`value_${filterName}_${groupIdx}_${idx}`"
								:value="{ name: item.name, nameChiclet: item.nameChiclet || item.name, value: item.value }"
								:disabled="!item.enabled"
								v-model="selectedItems"
								@change="handleStateChanged(item)"
							/>
							<span class="c-indicator"></span>
							<span :id="`filterName_${filterName}_${groupIdx}_${idx}`" v-if="!item.html">{{ item.name }}</span>
							<span v-if="item.html" v-html="item.html"></span>
						</label>
					</div>
				</fieldset>
			</div>
		</div>
		<span class="label-help ng-scope" v-if="!isValid && required">{{ required }}</span>
	</div>
</template>

<script>
import { defineComponent } from 'vue';
import vClickOutside from 'v-click-outside';
import _ from 'lodash';

export default defineComponent({
	name: 'Multiselect',
	directives: {
		clickOutside: vClickOutside.directive
	},
	props: {
		groups: {
			type: Array,
			default: () => []
		},
		filterName: {
			type: String,
			required: true
		},
		required: {
			type: String,
			default: null
		},
		placeholder: {
			type: String,
			required: true
		},
		hideOutsideClick: {
			type: Boolean,
			default: true
		},
		externalData: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			isMultiSelectActive: false,
			multiSelectMovers: [],
			selectedItems: [],
			selectVisible: false,
			isValid: true,
			items: [],
			forceDisabled: false,
			toggleButtonRef: `toggleButton_${this.filterName}`
		};
	},
	mounted() {
		this.items = this.groups;
		this.setSelectedValues();
	},
	methods: {
		getSelectedValues() {
			return _.map(this.selectedItems, item => item.value);
		},
		getSelectedObjects() {
			return this.selectedItems;
		},
		setGroups(groups, setValues) {
			this.items = groups;
			if (setValues) this.setSelectedValues();
		},

		handleStateChanged(item) {
			this.isValid = this.selectedItems.length > 0;
			this.$emit('change', item, this.externalData);
		},

		setSelectedValues() {
			const _selectedItems = [];
			for (const group of this.items) {
				for (const choice of group.choices) {
					if (choice.selected) {
						_selectedItems.push({
							name: choice.name,
							nameChiclet: choice.nameChiclet || choice.name,
							value: choice.value
						});
					}
				}
			}
			this.selectedItems = _selectedItems;
		},
		setSelected(value, triggerUpdate) {
			_.remove(this.selectedItems, item => {
				return item.value === value;
			}); // prevent possible duplicates
			let newItem = { name: value, nameChiclet: value, value: value };
			this.selectedItems.push(newItem);
			if (triggerUpdate) this.handleStateChanged(newItem);
		},
		setUnselected(value) {
			const removedItem = _.remove(this.selectedItems, item => {
				return item.value === value;
			});
			this.handleStateChanged(removedItem[0]); // _.remove returns an array, and we only want the one item
		},
		filteredGroupChoices(group) {
			return group.choices.filter(item => {
				return item.visible;
			});
		},
		isDisabled() {
			return this.forceDisabled || (this.items.length === 1 && this.items[0].choices.length === 0);
		},
		setForceDisabled(value) {
			this.forceDisabled = value;
		},

		toggle() {
			if (this.selectVisible) this.hide();
			else this.show();
		},
		handleOutsideClick() {
			if (this.hideOutsideClick) this.hide();
		},
		handleEscape() {
			this.$refs[this.toggleButtonRef].focus();
			this.hide();
		},
		show() {
			$('.multiselect-wrap', this.$el).slideDown(200); // TODO: Replace jQuery
			this.selectVisible = true;
		},
		hide() {
			$('.multiselect-wrap', this.$el).slideUp(200); // TODO: Replace jQuery
			this.selectVisible = false;
		}
	}
});
</script>
